export function toSentenceCase(str: string) {
    return str
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .replace(/(\d+\.\d+)|(\d+)/g, ' $& ')
        .replace(/^\w/, c => c.toUpperCase());
}
